<template>
  <div class="cooling-maintenance-parameters-tab">
    <b-row
      v-if="!loading"
      class="cooling-maintenance-parameters-tab__add no-internal-print"
      align-h="end"
    >
      <b-col
        class="mt-1"
        sm="auto"
      >
        <div class="add-group-button">
          <b-button
            v-if="$hasUserPermission('PER013')"
            variant="primary"
            @click="openGroupFormModal(modalTypes.INSERT)"
          >
            {{ $t('engineering.cooling-maintenance.add-group') }}
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col cols="12">
        <s-table
          class="cooling-maintenance-parameters-tab__table"
          :fields="fields"
          :items="items"
          :busy="loadingTable"
        >
          <template
            v-if="$hasUserPermission('PER013')"
            #cell(actions)="data">
            <div class="cooling-maintenance-parameters-tab-actions__group">
              <b-button
                class="cooling-maintenance-parameters-tab-actions__edit no-internal-print "
                variant="outline-primary"
                size="sm"
                @click="editParameter(data.item.id)"
              >
                <span class="fas fa-edit"/>
                {{ $t('actions.edit') }}
              </b-button>
              <b-button
                class="cooling-maintenance-parameters-tab-actions__delete no-internal-print"
                variant="primary"
                size="sm"
                @click="deleteParameterConfirmation(data.item.id)"
              >
                <span class="far fa-trash-alt"/>
                {{ $t('actions.delete') }}
              </b-button>
            </div>
          </template>
        </s-table>
      </b-col>
    </b-row>
    <group-form-modal
      v-model="showModal"
      :modal-type="selectedModalType"
      :groupId="groupId"
      @refresh="$emit('refresh')"
    />
  </div>
</template>

<script>
import modalTypes
  from '@/domain/enums/installation/engineering/coolingMaintenance/groupFormModalTypes';
import GroupFormModal
  from '@/domain/components/installation/engineering/coolingMaintenance/parameters/modal/GroupFormModal';
import Service
  from '@/domain/services/installation/engineering/coolingMaintenance/coolingMaintenanceService';
import eventBus from '@/services/globalEventBus';
import events from '@/domain/events/engineering';
import parametersFields
  from '@/domain/data/installation/engineering/coolingMaintenance/parametersFields';

export default {
  name: 'CoolingMaintenanceParametersTab',
  props: {
    loadingTable: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    GroupFormModal,
  },
  data: () => ({
    loading: false,
    items: [],
    showModal: false,
    selectedModalType: modalTypes.INSERT,
    modalTypes,
    groupId: null,
  }),
  computed: {
    fields() {
      return parametersFields(this);
    },
  },
  created() {
    this.getParameters(true);
    this.initListener();
  },
  beforeDestroy() {
    this.removeListener();
  },
  methods: {
    initListener() {
      eventBus.on(events.refreshDataTab, this.refreshDataEvent, this);
    },
    removeListener() {
      eventBus.off(events.refreshDataTab, this.refreshDataEvent, this);
    },
    refreshDataEvent() {
      this.getParameters();
    },
    getParameters(showLoading = false) {
      this.loading = showLoading;
      const { assetModuleId } = this.$route.params;
      return Service.getParameters(assetModuleId).then((data) => {
        this.items = data;
      }).finally(() => {
        this.loading = false;
      });
    },
    editParameter(groupId) {
      this.openGroupFormModal(modalTypes.UPDATE, groupId);
    },
    deleteParameterConfirmation(groupId) {
      this.$confirmMessage({ code: 'MC016' })
        .accepted(() => this.deleteParameter(groupId));
    },
    deleteParameter(groupId) {
      const { assetModuleId } = this.$route.params;
      Service.deleteGroupById(assetModuleId, groupId)
        .then(() => this.$pushAlert({ code: 'MS018' }))
        .finally(() => {
          this.getParameters();
        });
    },
    openGroupFormModal(modalType, groupId = '') {
      this.selectedModalType = modalType;
      this.groupId = groupId;
      this.showModal = true;
    },
  },
};
</script>
<style lang="sass" scoped>
::v-deep
  .cooling-maintenance-parameters-tab
    &-actions
      &__group
        display: flex
        justify-content: flex-end
        align-content: center

      &__edit
        margin-right: .5rem
        white-space: nowrap

      &__delete
        white-space: nowrap

  thead tr th
    white-space: normal !important
    padding: 5px 10px
</style>
